/**
 * The purposes a call can start a builder conversation for today (ADR-275).
 *
 * A published conversation is found by its purpose: the worker maps each call
 * to one of these and asks for the practice's conversation with that purpose.
 * A conversation with any other purpose can be written, checked and published,
 * and nothing will ever run it — so the builder offers these by name and says
 * so of anything else. The worker's own test holds this list to its routing
 * (`canonicalWorkflowIntent`), in both directions.
 */
export interface WorkflowPurpose {
  intent: string;
  label: string;
  direction: 'inbound' | 'outbound';
}

export const WORKFLOW_PURPOSES: readonly WorkflowPurpose[] = [
  { intent: 'identify_caller', label: 'Answer a caller we do not know yet', direction: 'inbound' },
  { intent: 'verify_caller', label: 'Confirm we reached the right person', direction: 'outbound' },
  { intent: 'schedule_referral', label: 'Schedule a referral', direction: 'outbound' },
];
